import { render, staticRenderFns } from "./FilterBedsQuantityBlock.vue?vue&type=template&id=88f2d046&"
import script from "./FilterBedsQuantityBlock.vue?vue&type=script&lang=js&"
export * from "./FilterBedsQuantityBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports